import React from 'react';

/**
 * Base class for react components that will be bound with redux.
 *
 * @param { OwnProps } - props expected to be passed explicitly
 * @param { StateProps } - props to be mapped with mapStateToProps
 * @param { DispatchProps } - props to be mapped with mapDispatchToProps
 * @param { InternalState } - the internal component state. Typically should be empty (i.e. "{}")
 */
export abstract class PresentationComponentBase<OwnProps, StateProps, DispatchProps, InternalState>
    extends React.Component<OwnProps & StateProps & DispatchProps, InternalState> {
}
